import { PRACTITIONER } from "@/core/constants";
import { CREATE_PRACTITIONER_PROFILE_MUTATION } from "@/graphql/accounts";
import useDjangoGraphqlForm from "@/hooks/form/useDjangoGraphqlForm";

import Common from "./CommonForm";

export default function LoggedOutForm({ setFormSubmitted }) {
  const api = useDjangoGraphqlForm({
    transformer: input => ({
      ...input,
      professionalBodies: input.professionalBodies.join(","),
      documents: JSON.stringify(
        input.documents.reduce((acc, doc) => {
          if (doc.type in acc) {
            return {
              ...acc,
              [doc.type]: [
                ...acc[doc.type],
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: doc.qualification_type
                }
              ]
            };
          } else {
            return {
              ...acc,
              [doc.type]: [
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: doc.qualification_type
                }
              ]
            };
          }
        }, {})
      )
    }),
    mutation: CREATE_PRACTITIONER_PROFILE_MUTATION,
    mutationName: "createPractitionerProfileMutation",
    defaultValues: {
      tier: PRACTITIONER,
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      dateOfBirth: "",
      gender: "",

      practitionerType: "",
      professionalBodies: [],
      documents: [],

      phoneNumber: "",
      jobRole: "",
      specialisms: [],
      businessName: "",
      businessLocationCity: "",
      businessCountry: "",

      acceptTerms: false
    },
    handleSuccess: () => {
      setFormSubmitted(true);
    }
  });

  return <Common api={api} showLoginLink showPasswordFields />;
}
